import Noty from 'noty'
import _ from 'lodash'

Noty.overrideDefaults({
  layout: 'topRight',
  theme: 'metroui',
  animation: {
    open: 'animated fadeInUp',
    close: 'animated fadeOutUp'
  }
})

export default {
  /**
   * Default notification method.
   *
   * @param object options
   *
   * @return Noty
   */
  notification (options) {
    const defaults = {
      timeout: 3000
    }

    try {
      return new Noty(_.merge(defaults, options)).show()
    } catch (error) {
      // Fail silently if Noty throws an exception...
    }
  },

  /**
   * Create a success notification.
   *
   * @param string text
   *
   * @return Noty
   */
  success (text) {
    return this.notification({ text, type: 'success' })
  },

  /**
   * Create a info notification.
   *
   * @param string text
   *
   * @return Noty
   */
  info (text) {
    return this.notification({ text, type: 'info' })
  },

  /**
   * Create an error notification.
   *
   * @param string text
   *
   * @return Noty
   */
  error (text) {
    return this.notification({ text, type: 'error' })
  },

  /**
   * Create a warning notification.
   *
   * @param string text
   *
   * @return Noty
   */
  warning (text) {
    return this.notification({ text, type: 'warning' })
  }
}



// WEBPACK FOOTER //
// ./src/utils/notify.js